import { Route, routes } from "./routes";

export const getValidPaths = (
	route: Route = routes,
	acc: string[] = [],
): readonly string[] => {
	acc.push(route.path);

	const map = route._;
	for (const key in map) {
		if (Object.prototype.hasOwnProperty.call(map, key)) {
			const val = map?.[key];
			if (val) {
				getValidPaths(val, acc);
			}
		}
	}

	return acc;
};

export const allPaths = getValidPaths();
